import axios from "axios";
const API_KEY = `AIzaSyCipXvMPGWkd8mw1SESiscvgMQ_Zj2tFgE`;
export const getDataYoutube = async (id: string) => {
  const response = await axios.get(
    `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${id}&key=${API_KEY}`
  );
  return response.data;
};
